import { simple_deep_equal } from './utils.js'; // profile conversion

export function convert_tagexp_to_profile_description(tagexp) {
  console.log('convert_tagexp_to_profile_description', tagexp);
  var r; // special regexps which include |, ( 

  r = tagexp.match(/^[^:]+:\S*(\||\()\S*$/);

  if (r) {
    return {
      tagexp: r[0]
    };
  } // must match dropdown in blocks!


  r = tagexp.match(/^dpasrv:(bdt|hfk|spe|mag|ctn|section-de-obs)$/);

  if (r) {
    return {
      dpasrv: r[0]
    };
  } // must match dropdown in blocks!
  // Landesdienste


  r = tagexp.match(/^dpasrv:(hsh|nsb|mbv|bwg|brb|bay|nwf|hes|rhs|san|aht|thg)$/);

  if (r) {
    return {
      dpasrv: r[0]
    };
  } // must match dropdown in blocks!
  // Fotodienste


  r = tagexp.match(/^dpasrv:(photostream-de|photostream-de-nat|photostream-de-int|photostream-de-3p|photostream-de-top|photostream-de-sel|photostream-plus|photostream-en|photostream-en-nat|photostream-en-int|photostream-en-3p|photostream-en-sports|photostream-en-top|photostream-en-sel|photostream-en-500|photostream-zb|photostream-ap-en)$/);

  if (r) {
    return {
      dpasrv: r[0]
    };
  } // must match dropdown in blocks!
  // Auslandsdienste 1


  r = tagexp.match(/^dpasrv:(eca|eca-3p|eca-mm|erd|erd-ch|erd-ch-mm|apx|apwire|europapress-tem|europapress-esp|europapress-int)$/);

  if (r) {
    return {
      dpasrv: r[0]
    };
  } // must match dropdown in blocks!
  // Auslandsdienste 2


  r = tagexp.match(/^dpasrv:(feature-en|feature-special-en-cars|feature-special-en-digital|feature-special-en-lifestyle|feature-special-en-science|feature-special-en-topstories|feature-special-en-travel|feature-es|feature-special-es-trend|feature-special-es-auto|feature-special-es-tourism|feature-special-es-tech|feature-special-es-pets|easy-news|germany-today-de|germany-today-en|germany-today-es|germany-today-ar|germany-today-fr|germany-today-pl|dpa-espanol|text-arabic|feature-ar|feature-consumer-ar)$/);

  if (r) {
    return {
      dpasrv: r[0]
    };
  } // must match dropdown in blocks!
  // newsaktuell


  r = tagexp.match(/^nasrv:(ots|neo|otsch)$/); // dpasrv:section-de-obs upper block

  if (r) {
    return {
      dpasrv: r[0]
    };
  }

  r = tagexp.match(/^afxsrv:(ADE|ADL|DRR)$/);

  if (r) {
    return {
      dpasrv: r[0]
    };
  } // must match dropdown in blocks!
  // dpa-news


  r = tagexp.match(/^dnlpath:(dpa-news.top|dpa-news.pol|dpa-news.eco|dpa-news.net|dpa-news.spo|dpa-news.pan|dpa-news.cul|dpa-news.sci|dpa-news.hsh|dpa-news.nsb|dpa-news.mbv|dpa-news.bwg|dpa-news.brb|dpa-news.bay|dpa-news.nwf|dpa-news.hes|dpa-news.rhs|dpa-news.san|dpa-news.aht|dpa-news.thg)$/);

  if (r) {
    return {
      dpasrv: r[0]
    };
  } // must match dropdown in blocks!


  r = tagexp.match(/^dnlpath:weblines\.(infoline|infoline_rs|starline|serviceline|regiolinegeo|regiolinecities|sportsline|newsscreen|juniorline|afxline|nextline|labline|zdf_myline)\.\*$/);

  if (r) {
    return {
      dnlpath_full_lines: r[0]
    };
  } // must match dropdown in blocks! -- more checks???


  r = tagexp.match(/^dnlpath:weblines\.(infoline|infoline_rs|starline|serviceline|regiolinegeo|regiolinecities|sportsline|newsscreen|juniorline|afxline|nextline|labline|zdf_myline)\.[^\.]+\.\*$/);

  if (r) {
    return {
      dnlpath_mainrubrics: r[0]
    };
  } // must match dropdown in blocks! -- more checks???


  r = tagexp.match(/^dnlpath:weblines\.(infoline|infoline_rs|starline|serviceline|regiolinegeo|regiolinecities|sportsline|newsscreen|juniorline|afxline|nextline|labline|zdf_myline)\.\S+$/);

  if (r) {
    return {
      dnlpath: r[0]
    };
  }

  r = tagexp.match(/^[^:]+:\S+$/);

  if (r) {
    return {
      tagexp: r[0]
    };
  }

  return null;
}
export function convert_profile_description_to_tagexp(p) {
  if (p.dnlpath) {
    return p.dnlpath; // return 'dnlpath:'+p.dnlpath
  } else if (p.dnlpath_full_lines) {
    return p.dnlpath_full_lines;
  } else if (p.dpa_news_full_lines) {
    return p.dpa_news_full_lines;
  } else if (p.dnlpath_mainrubrics) {
    return p.dnlpath_mainrubrics;
  } else if (p.dpasrv) {
    return p.dpasrv; // return 'dpasrv:'+p.dpasrv
  } else if (p.nasrv) {
    return p.nasrv; // return 'nasrv:'+p.nasrv 
  } else if (p.afxsrv) {
    return p.afxsrv; // return 'afxsrv:'+p.afxsrv 
  } else if (p.tagexp) {
    return p.tagexp;
  }

  return null;
}
export function convert_profile_query_ored_tag_regexps(profile) {
  return profile.map(convert_profile_description_to_tagexp).filter(function (s) {
    return !!s;
  });
} // cf. guess_extra()

export function convert_profile_extra(extras) {
  if (!extras || extras.length == 0) {
    return ' ';
  }

  if (extras.length == 1) {
    var extra = extras[0];

    if (simple_deep_equal(extra, {
      one_day_ago: true
    })) {
      return JSON.stringify({
        "range": {
          "version_created": {
            "to": "now-1d/m"
          }
        }
      });
    }

    if (extra.timewindow && extra.timewindowunit && ["h", "d"].find(function (u) {
      return extra.timewindowunit === u;
    })) {
      // return JSON.stringify({"range":{"version_created": {"from": `now-${extra.timewindow}${extra.timewindowunit}`}}})
      // always round to hour
      return JSON.stringify({
        "range": {
          "version_created": {
            "from": "now-".concat(extra.timewindow).concat(extra.timewindowunit, "/h")
          }
        }
      });
    }

    if (simple_deep_equal(extra, {
      provider: extra.provider
    })) {
      return JSON.stringify({
        "term": {
          "tags": extra.provider
        }
      });
    }
  }

  console.warn('could not convert extra', extras);
  return ' ';
} // cf. guess_format

export function generate_format_as_feed_options(formats) {
  if (!formats || formats.length == 0) {
    return {};
  }

  if (formats.length == 1 && formats[0].formatname) {
    return {
      required_format: formats[0].formatname,
      required_format_version: [formats[0].from, formats[0].to]
    };
  }

  console.warn('could not convert format', formats);
  return {};
} // cf. guess_image

export function generate_image_sizes(image) {
  return image.map(function (img) {
    if (img.size && !img.width && !img.height) {
      return parseInt(img.size);
    } else if (!img.size && img.width && img.height) {
      return [parseInt(img.width), parseInt(img.height)];
    }

    return null;
  }).filter(function (s) {
    return !!s;
  });
} // profile conversion end